import {ViewPopupLanguage} from '../ui_popup/ViewPopupLanguage.ts'
import {MorePageContainer} from '@colonist/ui-platform'
import {navigateToPage} from '../ui_utils/ClientUtils.ts'
import {mountUIReactComponent} from '../ui_platform/mountUIReactComponent.tsx'
import {StorageWrapper} from '../StorageWrapper.ts'

interface MountMorePageOptions {
    faqExternalUrl?: string
}

export function mountMorePage(containerId: string, onRulebookClick: () => void, options?: MountMorePageOptions) {
    mountUIReactComponent(containerId, MorePageContainer).render({
        onNavigate: (path: string) => navigateToPage(path, false, true),
        onExternalNavigate: (url: string) => navigateToPage(url, true),
        onLanguageClick: () => new ViewPopupLanguage(),
        onRulebookClick: onRulebookClick,
        initialShowCareersNotification: StorageWrapper.isCareersBadgeVisible(),
        dismissCareersNotification: () => StorageWrapper.setCareersBadgeDismissed(),
        ...options,
    })
}
